import React, { useEffect, useState } from "react";
import PaymentMethodsImages from "../assets/payment-methods.png";
import { FaRupeeSign } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ClarityPlanListApi } from "../services/Api";

function ClarityPlan() {
  const navigate = useNavigate();

  const [userPlan1, setUserPlan1] = useState("");
  const [userPlan2, setUserPlan2] = useState("");

  const getUserPlanList = async () => {
    const response = await ClarityPlanListApi();
    setUserPlan1(response.data[0]);
    setUserPlan2(response.data[0]);
  };

  useEffect(() => {
    getUserPlanList();
  }, []);
  
  return (
    <div className="wcc-plan-container">
      <div className="wcc-plan-left">
        <h2 className="wcc-plan-title">
          Pick the plan that’s <br />
          <span>Right for you</span>
        </h2>

        <p className="wcc-plan-desc">
          The right care begins with the right choice. <br />
          Choose the plan that sees you, <br />
          not just your problem.
        </p>
        <p className="wcc-plan-desc">
          It’s a gift to find good people. <br />
          It’s grace to hold onto them
        </p>


        <div className="wcc-plan-payments">
          <h4>Payment Methods</h4>
          <img
            src={PaymentMethodsImages}
            alt="Payment Methods"
            className="wcc-plan-payments-img"
          />
          <p className="wcc-plan-note">
            We accept Visa, American Express, Mastercard, Paypal and Crypto
          </p>
        </div>
      </div>

      <div className="wcc-plan-right">


        <div className="wcc-plan-card-alt">
          <div className="goodcall-plan-pricing-amount-container">
            <FaRupeeSign size={20} />
            <p className="wcc-plan-price">{userPlan2.amount}</p>
          </div>
          <p className="wcc-plan-sessions white">
            2 Counselling sessions(Voice or Video)
          </p>

          <p className="wcc-plan-label white">Add One's :</p>
          <p className="wcc-plan-label white">
            1. Unlimited user to user calls
          </p>
          <p className="wcc-plan-label white">2. Sleep Wellness</p>
          <p className="wcc-plan-label white">3. Podcast</p>
          <p className="wcc-plan-label white">4. Mindful Reminders</p>
          <p className="wcc-plan-label white">5. Interactive sessions</p>

          <p className="wcc-plan-label white">6. Psychometrics</p>

          <button
            className="wcc-plan-button-yellow"
            onClick={() => {
              navigate("/wccbuy", {
                state: {
                  planId: userPlan2.id,
                  amount: userPlan2.amount,
                },
              });
            }}
          >
            Contact Program Manager
          </button>
        </div>
      </div>
    </div>
  );
}

export default ClarityPlan;
